export default {
    // 查询操作日志
    queryOperationLog(params, response) {
        window.vue.$apiAxios.postRequestBody('/log/queryOperationLog', params, response);
    },
    // 导出操作日志
    exportOperationLog(params, responseType, response) {
        window.vue.$apiAxios.downloadPost('/log/exportOperationLog', params, responseType, response);
    },
    // 查询树形
    findTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTree', params, response);
    },
    // 根据设备名称查询设备
    findDeviceTreeByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTreeByName', params, response);
    },
    // 查询用户树形
    findUserTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/staffManager/queryStaffOrgTreeForLog', params, response);
    },
    // 查询用户名称查询用户
    findUserTreeByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/staffManager/getStaffInfoByCaptionForLog', params, response);
    },
    // 查询所有操作资源
    getAllResType(params, response) {
        window.vue.$apiAxios.get('/log/getAllResTypeByLogSysId', params, response);
    },

    // 查询所有操作级别
    getAllOperationLevel(params, response) {
        window.vue.$apiAxios.get('/log/getAllOperationLevel', params, response);
    },
    // 获取所有操作类型
    getAllOperationType(params, response) {
        window.vue.$apiAxios.postRequestBody('/log/getAllOperationType', params, response);
    },
    // 获取系统url
    getSysInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/listSysList', params, response);
    },
    //获取所有用户
    getAllUsers(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserInfos', params, response);
    },
    //获取cassandra最大查询数量
    getMaxLimitCount(params, response) {
        window.vue.$apiAxios.get('/log/getMaxLimitCount', params, response);
    },
    //获取所有组织类型
    getOrgTypes(params, response) {
        window.vue.$apiAxios.get('/OrgManagerController/findOrgTypes', params, response);
    }
};
